// extracted by mini-css-extract-plugin
export default {"notification":"MessageNotification_notification__S38gD","message":"MessageNotification_message__Twjg-","closeIcon":"MessageNotification_closeIcon__zKCki"};